import pageheader from "../../pageheader";
import CustomerScopeNotice from "@/components/Common/CustomerScopeNotice";
import { mapGetters } from "vuex";
import utils from "../../../utils/util";
import telematicsService from "../../../api/telematics.service";
import rules from "../../../utils/rules";
export default {
  name: "access-control-codes-list",
  components: { pageheader, CustomerScopeNotice },
  data() {
    return {
      input: {},
      customerList: [],
      selectedCustomer: null,
      isLoaderCustomer: false,
      searchCustomer: null,
      selectedCompanyName: "",
      tabType: "",
      isGlobal:false,
      tabModel: 0,
      birchSearch: "",
      isGetBirchAccessKeys: false,
      birchAccessCodesList: [],
      customerSearch: "",
      customerAccessCodesList: [],
      isGetCustomerAccessKeys: false,
      accessControlCodeDialog: false,
      birchHeaders: [
        { text: "Company Name", value: "companyName" },
        { text: "Name", value: "name" },
        { text: "Serial Number", value: "serialNumber" },
        { text: "Key Valid", value: "keyValid" },
        { text: "Key Expire", value: "keyExpire" },
        { text: "Note", value: "note" },
        { text: "Actions", value: "action" },
      ],
      extendedInfoId:"",
      customerHeaders: [
        { text: "Name", value: "name" },
        { text: "Serial Number", value: "serialNumber" },
        { text: "Key Valid", value: "keyValid" },
        { text: "Key Expire", value: "keyExpire" },
        { text: "Note", value: "note" },
        { text: "Actions", value: "action" },
      ],
      typeOfOperation: "",
      controlCodeFormValid: true,
      rules: rules,
      defaultAccessControlCodeId: "",
      controlCodeName: "",
      controlCodeSerialNumber: "",
      keyValidList: [
        { name: "30sec", value: "30sec" },
        { name: "60sec", value: "60sec" },
        { name: "90sec", value: "90sec" },
      ],
      selectedKeyValid: "",
      keyExpireList: [
        { name: "0sec", value: "0sec" },
        { name: "15sec", value: "15sec" },
        { name: "30sec", value: "30sec" },
        { name: "60sec", value: "60sec" },
        { name: "2min", value: "2min" },
        { name: "5min", value: "5min" },
        { name: "10min", value: "10min" },
        { name: "15min", value: "15min" },
        { name: "30min", value: "30min" },
        { name: "1hour", value: "1hour" },
        { name: "2hours", value: "2hours" },
        { name: "4hours", value: "4hours" },
        { name: "8hours", value: "8hours" },
        { name: "16hours", value: "16hours" },
      ],
      selectedKeyExpire: "",
      controlCodeNotes: "",
      isBtnSubmit: false,
      unitIdsList: [],
    };
  },
  created() {
    this.tabModel = this.accessTabsVal;
  },
  computed: {
    ...mapGetters(["roles", "companyIdDropdown", "accessTabsVal"]),
  },
  mounted() {
    this.input = utils.getInputContent("accessControlCodes", this.roles);
    if (this.roles != "Customer") {
      if (this.tabModel == 0) {
        this.getBirchAccessCodesList();
      } else {
        this.getCustomerAccessCodesList();
      }
    } else {
      if (this.tabModel == 0) {
        this.getCustomerAccessCodesList();
      }
    }
  },
  watch: {
    // BE-1121: follow the toolbar customer. The Birch-owned tab is fleet-wide,
    // so only the customer-owned list is refetched.
    companyIdDropdown() {
      this.customerAccessCodesList = [];
      const onCustomerTab = this.roles == "Customer" || this.tabModel == 1;
      if (onCustomerTab) {
        this.getCustomerAccessCodesList();
      }
    },
    searchCustomer(val) {
      //check entered text is not undefined and enter search text is multiples of 2 characters
      if (val != undefined && val != "All" && val.length % 2 == 0) {
        this.searchCustomers(val);
      }
    },
  },
  methods: {
    async searchCustomers(value) {
      try {
        this.isLoaderCustomer = true;
        const response = await telematicsService.searchBasicCustomers(value);
        if (response.isSuccess) {
          let finaldata = response.data.filter((e) => e.name !== "");
          this.customerList = finaldata.map((item) => {
            return {
              name: item.name ? item.name : "",
              id: String(item.id) ? String(item.id) : "",
            };
          });
          this.isLoaderCustomer = false;
        } else {
          this.isLoaderCustomer = false;
        }
      } catch (err) {
        this.isLoaderCustomer = false;
        console.log(err);
      }
    },
    tabChange() {
      this.$store.dispatch("setAccessTabVal", Number(this.tabModel));
      this.tabModel = this.accessTabsVal;
      this.birchSearch = "";
      this.customerSearch = "";
    },
    clearBirchSearch() {
      this.birchSearch = "";
    },
    clearCustomerSearch() {
      this.customerSearch = "";
    },
    async getBirchAccessCodesList() {
      this.tabType = "birch";
      this.isGetBirchAccessKeys = true;
      this.birchAccessCodesList = [];
      try {
        let response = await telematicsService.getBirchAccessCodesList();
        if (response && response.data) {
          this.isGetBirchAccessKeys = false;
          this.birchAccessCodesList = response.data;
        } else {
          this.isGetBirchAccessKeys = false;
          this.birchAccessCodesList = [];
        }
      } catch (err) {
        this.isGetBirchAccessKeys = false;
        console.log(err);
      }
    },
    async getCustomerAccessCodesList() {
      this.tabType = "cust";

      // Nothing to fetch until a customer is chosen; CustomerScopeNotice says so.
      if (this.companyIdDropdown) {
        this.isGetCustomerAccessKeys = true;
        this.customerAccessCodesList = [];
        try {
          let response = await telematicsService.getCustomerAccessCodesList(
            this.companyIdDropdown
          );
          if (response && response.data) {
            this.isGetCustomerAccessKeys = false;
            this.customerAccessCodesList = response.data;
          } else {
            this.isGetCustomerAccessKeys = false;
            this.customerAccessCodesList = [];
          }
        } catch (err) {
          this.isGetCustomerAccessKeys = false;
          console.log(err);
        }
      }
    },
    openEditAccessControlDialog(item) {
      this.clearControlCodeFields();
      this.accessControlCodeDialog = true;
      this.typeOfOperation = "Update";
      this.defaultAccessControlCodeId = item.id;
      this.extendedInfoId= item.extendedInfoId,
      this.controlCodeName = item.name;
      this.selectedCompanyName = item.companyName;
      if(this.tabType=='birch'){
      this.searchCustomers(item.customerName);
      this.selectedCustomer = {
        id: item.customerId,
        name:item.customerName
      }
    }
    else{
      this.selectedCustomer = null;
    }
      this.isGlobal = item.isGlobal != undefined? item.isGlobal : false,
      this.controlCodeSerialNumber = item.serialNumber;
      this.selectedKeyExpire = item.keyExpire;
      this.selectedKeyValid = item.keyValid;
      this.controlCodeNotes = item.note;
      this.unitIdsList = item.equipments;
    },
    cancelAccessControlDialog() {
      this.accessControlCodeDialog = false;
      this.typeOfOperation = "";
      this.clearControlCodeFields();
    },
    // Keys shared by every create/update payload, in their original order so
    // the serialized body is unchanged when spread between the leading
    // id/ownerType key and the trailing owner-specific keys.
    controlCodeFields() {
      return {
        name: this.controlCodeName,
        serialNumber: this.controlCodeSerialNumber,
        keyValid: this.selectedKeyValid,
        keyExpire: this.selectedKeyExpire,
        note: this.controlCodeNotes,
        isGlobal: this.isGlobal,
      };
    },
    selectedCustomerFields() {
      return {
        customerName:
          this.selectedCustomer != null ? this.selectedCustomer["name"] : "",
        customerId:
          this.selectedCustomer != null
            ? String(this.selectedCustomer["id"])
            : "",
      };
    },
    clearControlCodeFields() {
      this.controlCodeName = "";
      this.selectedCompanyName = "";
      this.selectedCustomer=null;
      this.controlCodeSerialNumber = "";
      this.selectedKeyExpire = "";
      this.selectedKeyValid = "";
      this.controlCodeNotes = "";
      this.unitIdsList = [];
    },
    async updateAccessControlCode() {
      this.isBtnSubmit = true;
      let extendedInfoId = this.extendedInfoId;
      let customerId, ownerType;
      if (this.roles != "Customer") {
        if (this.tabModel == 0) {
          customerId = "";
          ownerType = "1";
        } else {
          customerId = this.companyIdDropdown;
          ownerType = "2";
        }
      } else {
        if (this.tabModel == 0) {
          customerId = this.companyIdDropdown;
          ownerType = "2";
        }
      }

      let payload1= {
        id: this.defaultAccessControlCodeId,
        ...this.controlCodeFields(),
        companyName:this.selectedCompanyName,
        ...this.selectedCustomerFields(),
      };
      let payload2 = {
        id: this.defaultAccessControlCodeId,
        ...this.controlCodeFields(),
        customerId:String(this.companyIdDropdown),
      };
      let payload;

      if(this.tabType=='birch'){
        payload = payload1
      }
      else if(this.tabType=='cust'){
        payload = payload2
      }
      try {
        let response = await telematicsService.updateAccessControlCodeDetails(extendedInfoId,customerId,
          ownerType,
          payload
        );
        if (response.isSuccess) {
          this.$toast.success(
            "Access control code has been updated successfully."
          );
          this.isBtnSubmit = false;
          this.cancelAccessControlDialog();
          if (this.roles != "Customer") {
            if (this.tabModel == 0) {
              this.getBirchAccessCodesList();
            } else {
              this.getCustomerAccessCodesList();
            }
          } else {
            if (this.tabModel == 0) {
              this.getCustomerAccessCodesList();
            }
          }
        } else {
          this.$toast.error("Failed to update the access control code");
          this.isBtnSubmit = false;
        }
      } catch (err) {
        console.log(err);
        this.$toast.error("Unable to update the access control code" + err);
        this.isBtnSubmit = false;
      }
    },
    openCreateAccessControlDialog() {
      this.typeOfOperation = "Add";
      this.accessControlCodeDialog = true;
    },
    //Post Call Create Access Control Code
    async createAccessControlCode() {
      this.isBtnSubmit = true;
      let  ownerType;
      if (this.roles != "Customer") {
        if (this.tabModel == 0) {
         
          ownerType = "1";
        } else {
         
          ownerType = "2";
        }
      } else {
        if (this.tabModel == 0) {
         
          ownerType = "2";
        }
      }

      let payload1= {
        ownerType: ownerType,
        ...this.controlCodeFields(),
        companyName:this.selectedCompanyName,
        ...this.selectedCustomerFields(),
      };
      let payload2 = {
        ownerType: ownerType,
        ...this.controlCodeFields(),
        customerId:String(this.companyIdDropdown),
      };
      let payload;

      if(this.tabType=='birch'){
        payload = payload1
      }
      else if(this.tabType=='cust'){
        payload = payload2
      }
      try {
        let response = await telematicsService.createAccessControlCode(payload);
        if (response.isSuccess) {
          this.$toast.success(
            "Access control code has been created successfully."
          );
          this.isBtnSubmit = false;
          this.cancelAccessControlDialog();
          if (this.roles != "Customer") {
            if (this.tabModel == 0) {
              this.getBirchAccessCodesList();
            } else {
              this.getCustomerAccessCodesList();
            }
          } else {
            if (this.tabModel == 0) {
              this.getCustomerAccessCodesList();
            }
          }
        } else {
          this.$toast.error(
            "Failed to create the access control code. please try again after sometime."
          );
          this.isBtnSubmit = false;
        }
      } catch (err) {
        console.log(err);
        this.$toast.error("Unable to create the access control code" + err);
        this.isBtnSubmit = false;
      }
    },
  },
};
